// styled components
import {
    Link,
    SingleLink,
    StyledAccordion,
    StyledAccordionDetails,
    StyledAccordionSummary,
    StyledDrawer
}
    from './styles';

// components
import Logo from '@components/Logo';
import { NavLink, useLocation } from 'react-router-dom';

// hooks
import { useSidebar } from '@contexts/sidebarContext';
import { useWindowSize } from 'react-use';
import { useEffect, useState } from 'react';
import { useAuth } from '@contexts/authContext';


const Sidebar = () => {
    const { links } = useAuth();

    const { open, setOpen } = useSidebar();

    const [expanded, setExpanded] = useState(undefined);
    const { pathname } = useLocation();
    const { width } = useWindowSize();

    // manually handle accordion expansion
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    }

    // collapse opened accordion on route change when the drawer is temporary
    useEffect(() => {
        width < 1280 && setExpanded(undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return (
        <StyledDrawer
            variant={width < 1920 ? 'temporary' : 'permanent'}
            anchor="left"
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            sx={{
                '& .MuiDrawer-paper': {
                    width: 250,
                }
            }}
            className="main-sidebar">
            <div className="logo-wrapper">
                <Logo size="sm" />
            </div>
            <SingleLink className={pathname === '/' ? 'pinned active' : 'pinned'} as="div">
                <NavLink to="/">
                    <Link className={`${pathname === '/' ? '' : ''} h4`}>
                        <i className="icon icon-home" /> Inicio
                    </Link>
                </NavLink>
            </SingleLink>

            <nav className="d-flex flex-column g-8 flex-1">
                {
                    links.map((link, index) => (
                        <StyledAccordion key={link.title}
                            expanded={expanded === `panel${index}`}
                            onChange={handleChange(`panel${index}`)}>
                            <StyledAccordionSummary>
                                <Link className={`${expanded === `panel${index}` ? 'active' : 'active'} h4`}>
                                    <i className={`icon icon-${link.icon}`} /> {link.title}
                                </Link>
                                <i className="icon icon-chevron-down" />
                            </StyledAccordionSummary>
                            <StyledAccordionDetails>
                                {
                                    link.pages.map(page => (
                                        <NavLink to={page.path} key={page.title}>
                                            {page.title}
                                        </NavLink>
                                    ))
                                }
                            </StyledAccordionDetails>
                        </StyledAccordion>
                    ))
                }
            </nav>
            <SingleLink className={pathname === '/statics' ? 'pinned active' : 'pinned'} as="div">
                <Link className={`${pathname === '/schedule' ? 'active' : ''} h4`}>
                    <a
                        href="https://chat.whatsapp.com/FSNbmES4AqjD8P2Hh6PaoK?mode=ems_copy_c"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="h4"
                    >
                        Grupos de WhatsApp


                    </a>
                </Link>
            </SingleLink>
            <SingleLink className={pathname === '/statics' ? 'pinned active' : 'pinned'} as="div">
                <Link className={`${pathname === '/schedule' ? 'active' : ''} h4`}>
                    <a
                        href="https:///torneospyd.com/REGLAMENTO_2026.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="h4"
                    >
                        Reglamentación


                    </a>
                </Link>
            </SingleLink>
            <SingleLink className={pathname === '/statics' ? 'pinned active' : 'pinned'} as="div">
                <NavLink to="/schedule">
                    <Link className={`${pathname === '/schedule' ? 'active' : ''} h4`}>
                        <i className="icon icon-calendar" /> Calendario
                    </Link>
                </NavLink>
            </SingleLink>

        </StyledDrawer>
    );
}

export default Sidebar